// src/utils/uploadFile.js
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "../firebase";

/**
 * Upload a file to Firebase Storage with progress tracking
 * @param {File} file - File to upload
 * @param {string} path - Storage path e.g. "blogs/thumbnails"
 * @param {function} onProgress - Callback(percent: number)
 * @returns {Promise<string>} Download URL
 */
export function uploadFile(file, path, onProgress = () => {}) {
  return new Promise((resolve, reject) => {
    const fileName = `${Date.now()}_${file.name.replace(/[^a-zA-Z0-9._-]/g, "_")}`;
    const storageRef = ref(storage, `${path}/${fileName}`);
    const task = uploadBytesResumable(storageRef, file);

    task.on(
      "state_changed",
      (snapshot) => {
        const pct = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        onProgress(pct);
      },
      (error) => {
        console.error("Upload error:", error);
        reject(error);
      },
      async () => {
        const url = await getDownloadURL(task.snapshot.ref);
        resolve(url);
      }
    );
  });
}

/**
 * Delete a file from Firebase Storage by its download URL
 * @param {string} url - The download URL of the file
 */
export async function deleteFile(url) {
  try {
    const fileRef = ref(storage, url);
    await deleteObject(fileRef);
  } catch (error) {
    console.error("Delete file error:", error);
  }
}
